import './styles.css';

const SkeletonLoader = () => {

    return (
        <div className='skeleton'></div>
    )
};

export default SkeletonLoader;